/* eslint-disable no-undef */
/**
 * BFPs is a unique case of the webview, since the main content is already in a render kit
 *  that has fully functional modular client code (often including react).  Thus, for the wrapping setup
 *  it is preferred to avoid an additional set of full react code.  So the server render is just a stringified
 *  version of the server HTML, with no additional client code.  This means this function needs to be fully operational
 *  as a standalone <script> that will not have any additional compiling.  Any functions referenced must also be defined.
 *  Therefore cannot import functions from bf-utils or other packages easily, and have to re-define some of
 *  abstraction logic.
 * Also, since it will not be further compiled, ALL comments will be included in the client, so any information
 *  you would not want end users to see should not be included
 *
 *  This function does the following, which gets called on window load.
 *    - Loads the render kit javascript from provided URL, this is needed for any BFP client implementation
 *    - Checks if there is an xsrf cookie (and if not generates a random one) - some auth based calls require
 *      a value in this cookie, and will 400 without
 *    - Does some enhanced webview specific logic (checks if cet is supported and pulls
 *      out relevant fields)
 *    - Adds CET info in format expected by BFPs (as part of bfp init, and tracking div).
 *      Note: assumes any enhanced webview integration, the native app is using
 *      at least version 3 of "cet" feature contract.
 *    - Initialize BFP, this is needed for any BFP client implementation
 */

export function windowLoad({ fields, islandMock = null }) {
  function loadScript(url, parent = document.head, isAsync = true) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.onload = () => resolve(script);
      script.onerror = () => {
        reject(`Script at url ${url} failed to load`);
      };
      script.src = url;
      script.async = isAsync;
      script.type = 'text/javascript';
      parent.appendChild(script);
    });
  }
    loadScript(fields.renderKitUrl).then(() => {
    const element = document.getElementById(`bfp-${fields.bfpId}-${fields.contentObjectId}`);
    if (element) {
      try {
        const xsrfCookie = getCookie('_xsrf');
        if (!xsrfCookie) {
          const newXsrfCookie = Math.random().toString(36).substring(2);
          document.cookie = '_xsrf=' + newXsrfCookie + '; path=/';
        }
        if (islandMock) {
          window.BZFD_APP = islandMock;
        }
        const CETSource = getCETSource();

        fields.context.clientEventTracking.source = CETSource;

        if (CETSource.endsWith('app_v3')) {
          // if within app, always add context
          const trackingElement = document.getElementById(`bfp-${fields.bfpId}-${fields.contentObjectId}-tracking`);
          if (trackingElement) {
            trackingElement.innerHTML = JSON.stringify(fields.context.clientEventTracking);
          }
        } else {
          if (CETSource.startsWith('island')) {
            // page edition is not relevant for app context
            fields.context.clientEventTracking.page_edition = 'en-us';
          }
        }

        window[`bfp_${fields.bfpFormatName}`].init({
          element: element,
          config: {
            data: fields.bfpData,
            context: fields.context,
          },
          broadcast: () => {}
        });
      } catch (e) {
        console.error('Unable to load: ' + e.message);
      }
    }
  }).catch((error) => {
    console.error(error);
  });
}
